import LogoBPD from "@/assets/logos/bpd.png";
import LogoBRI from "@/assets/logos/bri.png";
import LogoBTN from "@/assets/logos/logo-btn.png";
import LogoMandiri from "@/assets/logos/logo-mandiri.png";
import LogoBNI from "@/assets/logos/bni.png";
import LogoBSI from "@/assets/logos/bsi.png";
import { Role } from "@/types";
import React from "react";
import { AiFillDatabase } from "react-icons/ai";
import {
  FaBitcoin,
  FaBook,
  FaFilePdf,
  FaUserCheck,
  FaUserTie,
} from "react-icons/fa6";
import { GiTrophy } from "react-icons/gi";
import { IoBarChartSharp, IoBook, IoConstructSharp } from "react-icons/io5";
import { LuActivity, LuCheckCheck } from "react-icons/lu";
import { MdDashboard, MdMeetingRoom, MdSync } from "react-icons/md";
import {
  RiComputerFill,
  RiContactsBook3Fill,
  RiSettings3Fill,
} from "react-icons/ri";
import { web } from "@/config/System";

type SubMenu = {
  name: string;
  path: string;
};

type Menu = {
  icon: React.ReactElement;
  name: string;
  path: string | null;
  submenus?: SubMenu[];
};

export type Navigation = {
  title: string;
  menus: Menu[];
};

export const superAdminNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        icon: <MdDashboard size={25} />,
        name: "Dashboard",
        path: "/admin/dashboard",
      },
      {
        icon: <FaUserTie size={25} />,
        name: "Data Siswa",
        path: "/admin/data-siswa",
      },
      {
        icon: <RiContactsBook3Fill size={25} />,
        name: "Data Pendaftaran",
        path: "/admin/data-pendaftaran",
      },
      {
        icon: <GiTrophy size={25} />,
        name: "Data Prestasi",
        path: "/admin/data-prestasi",
      },
      {
        icon: <FaBitcoin size={25} />,
        name: "Data UKT Lulus",
        path: "/admin/data-ukt-pendaftar-lulus",
      },
    ],
  },
  {
    title: "MASTER",
    menus: [
      {
        icon: <AiFillDatabase size={25} />,
        name: "Master Data",
        path: null,
        submenus: [
          { name: "User", path: "/admin/master/user" },
          { name: "Jalur", path: "/admin/master/jalur" },
          { name: "Jalur Grup", path: "/admin/master/jalur-group" },
          { name: "Jalur Jenis", path: "/admin/master/jalur-jenis" },
          { name: "Jenis Tinggal", path: "/admin/master/jenis-tinggal" },
          { name: "Jenis Aset", path: "/admin/master/jenis-aset" },
          { name: "Luas Aset", path: "/admin/master/luas-aset" },
          {
            name: "Pembayaran Air Aset",
            path: "/admin/master/pembayaran-air-aset",
          },
          {
            name: "Tegangan Listrik Aset",
            path: "/admin/master/tegangan-listrik-aset",
          },
          {
            name: "Hubungan Keluarga",
            path: "/admin/master/hubungan-keluarga",
          },
          { name: "Agama", path: "/admin/master/agama" },
          {
            name: "Alat Transportasi",
            path: "/admin/master/alat-transportasi",
          },
          { name: "Negara", path: "/admin/master/negara" },
          { name: "Level Wilayah", path: "/admin/master/level-wilayah" },
          { name: "Wilayah", path: "/admin/master/wilayah" },
          { name: "Unitkerja Group", path: "/admin/master/unitkerja-group" },
          { name: "Unitkerja", path: "/admin/master/unitkerja" },
          {
            name: "Konsentrasi Prodi",
            path: "/admin/master/konsentrasi-prodi",
          },
          {
            name: "Jenjang Pendidikan",
            path: "/admin/master/jenjang-pendidikan",
          },
          {
            name: "Kepemilikan Asset",
            path: "/admin/master/kepemilikan-asset",
          },
          {
            name: "Jenis Prestasi",
            path: "/admin/master/jenis-prestasi",
          },
          {
            name: "Jenjang Prestasi",
            path: "/admin/master/jenjang-prestasi",
          },
          {
            name: "Capaian Prestasi",
            path: "/admin/master/capaian-prestasi",
          },
          {
            name: "Grup Prestasi",
            path: "/admin/master/grup-prestasi",
          },
          {
            name: "Pangkat Golongan",
            path: "/admin/master/pangkat-golongan",
          },
          {
            name: "Pekerjaan",
            path: "/admin/master/pekerjaan",
          },
          {
            name: "Jumlah Tanggungan",
            path: "/admin/master/jumlah-tanggungan",
          },
          {
            name: "Sumber Air",
            path: "/admin/master/sumber-air",
          },
          {
            name: "Sumber Listrik",
            path: "/admin/master/sumber-listrik",
          },
          {
            name: "Jenis Berkas",
            path: "/admin/master/jenis-berkas",
          },
          {
            name: "Sekolah",
            path: "/admin/master/sekolah",
          },
          {
            name: "Jurusan Sekolah",
            path: "/admin/master/jurusan-sekolah",
          },
          {
            name: "Perguruan Tinggi",
            path: "/admin/master/perguruan-tinggi",
          },
          {
            name: "Perguruan Tinggi Prodi",
            path: "/admin/master/perguruan-tinggi-prodi",
          },
          {
            name: "Penghasilan",
            path: "/admin/master/penghasilan",
          },
          {
            name: "SDM",
            path: "/admin/master/sdm",
          },
          {
            name: "Kebutuhan Khusus",
            path: "/admin/master/kebutuhan-khusus",
          },
          {
            name: "SPK",
            path: "/admin/master/spk",
          },
          {
            name: "Jenis Biaya",
            path: "/admin/master/jenis-biaya",
          },
          {
            name: "Jenis UKT",
            path: "/admin/master/jenis-ukt",
          },
          {
            name: "Nominal UKT",
            path: "/admin/master/nominal-ukt",
          },
          // {
          //   name: "Layanan Smart Payment",
          //   path: "/admin/master/layanan-smart-payment",
          // },
          {
            name: "Layanan Plaza",
            path: "/admin/master/layanan-plaza",
          },
          {
            name: "Jalur Feeder",
            path: "/admin/master/jalur-feeder",
          },
          {
            name: "Daftar Program",
            path: "/admin/master/daftar-program",
          },
        ],
      },
    ],
  },
  {
    title: "SETTING",
    menus: [
      {
        icon: <RiSettings3Fill size={25} />,
        name: "Setting Periode",
        path: null,
        submenus: [
          { name: "Periode", path: "/admin/setting/periode" },
          {
            name: "Berkas Portofolio",
            path: "/admin/setting/berkas-portofolio",
          },
        ],
      },
      {
        icon: <FaUserCheck size={25} />,
        name: "Setting Verifikator",
        path: null,
        submenus: [
          { name: "Verifikator UKT", path: "/admin/setting/verifikator/ukt" },
          {
            name: "Verifikator Butawarna",
            path: "/admin/setting/verifikator/butawarna",
          },
          {
            name: "Verifikator Sehat",
            path: "/admin/setting/verifikator/surat-keterangan-sehat",
          },
          {
            name: "Verifikator Raport",
            path: "/admin/setting/verifikator/raport",
          },
          {
            name: "Verifikator SKL",
            path: "/admin/setting/verifikator/skl",
          },
          {
            name: "Verifikator Kepemimpinan",
            path: "/admin/setting/verifikator/kepemimpinan",
          },
        ],
      },
      {
        icon: <MdMeetingRoom size={25} />,
        name: "Setting Ruang CBT",
        path: null,
        submenus: [
          { name: "Ruang CBT", path: "/admin/setting/ruang-cbt" },
          { name: "Ruang CBT Detail", path: "/admin/setting/ruang-cbt/detail" },
          { name: "Tahapan CBT", path: "/admin/setting/ruang-cbt/tahapan" },
        ],
      },
      {
        icon: <RiComputerFill size={25} />,
        name: "System",
        path: "/admin/setting/system",
      },
      {
        icon: <IoConstructSharp size={25} />,
        name: "Maintenance",
        path: "/admin/setting/maintenance",
      },
    ],
  },
  {
    title: "SYNC",
    menus: [
      {
        icon: <MdSync size={25} />,
        name: "Sinkronisasi",
        path: null,
        submenus: [
          {
            name: "Sync Mata Pelajaran",
            path: "/admin/sync/mata-pelajaran",
          },
          {
            name: "Sync Nilai Rapor",
            path: "/admin/sync/nilai-rapor",
          },
          {
            name: "Sync Nilai CBT",
            path: "/admin/sync/nilai-cbt",
          },
          {
            name: "Sync Pembayaran UKT",
            path: "/admin/sync/data-pembayaran-ukt",
          },
        ],
      },
    ],
  },
  {
    title: "GENERATE",
    menus: [
      {
        icon: <FaFilePdf />,
        name: "Sertifikat CBT",
        path: "/admin/sertifikat-cbt/index",
      },
    ],
  },
  {
    title: "LOGS",
    menus: [
      {
        icon: <LuActivity size={25} />,
        name: "Log Activities",
        path: "/admin/logs/activities",
      },
    ],
  },
];

export const verifikatorNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/verifikator/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Verifikasi Berkas",
        path: "/verifikator/verifikasi-berkas",
        icon: <LuCheckCheck size={25} />,
      },
    ],
  },
];

export const verifikatorRaportNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/verifikator/raport/dashboard",
        icon: <MdDashboard size={25} />,
      },
      // {
      //   name: "Verifikasi Raport Peserta",
      //   path: "/verifikator/raport/verifikasi-raport-peserta",
      //   icon: <LuCheckCheck size={25} />,
      // },
      {
        name: "Verifikasi Raport SMBJM",
        path: "/verifikator/raport/verifikasi-nilai-raport-smbjm",
        icon: <LuCheckCheck size={25} />,
      },
    ],
  },
];

export const verifikatorSklNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/verifikator/skl/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Verifikasi SKL",
        path: "/verifikator/skl/verifikasi-skl-peserta",
        icon: <LuCheckCheck size={25} />,
      },
    ],
  },
];

export const verifikatorButawarnaNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/verifikator/butawarna/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Verifikasi Peserta Butawarna",
        path: "/verifikator/butawarna/verifikasi-peserta-butawarna",
        icon: <LuCheckCheck size={25} />,
      },
    ],
  },
];

export const verifikatorSehatNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/verifikator/surat-keterangan-sehat/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Verifikasi Peserta Sehat",
        path: "/verifikator/surat-keterangan-sehat/verifikasi-peserta-surat-keterangan-sehat",
        icon: <LuCheckCheck size={25} />,
      },
    ],
  },
];

export const verifikatorKepemimpinanNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Verifikasi Peserta Kepemimpinan SMBJM",
        path: "/verifikator/kepemimpinan/verifikasi-peserta-kepemimpinan-smbjm",
        icon: <LuCheckCheck size={25} />,
      },
    ],
  },
];

export const operatorPascaNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/operator-pasca/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Data Pendaftaran",
        path: "/operator-pasca/data-pendaftaran",
        icon: <RiContactsBook3Fill size={25} />,
      },
      {
        icon: <IoBook size={25} />,
        name: "Data LOA",
        path: "/operator-pasca/data-loa",
      },
      {
        icon: <IoBarChartSharp size={25} />,
        name: "Data Nilai",
        path: "/operator-pasca/data-nilai",
      },
      {
        name: "Elearning",
        path: "/operator-pasca/users-elearning",
        icon: <FaBook size={25} />,
      },
    ],
  },
  {
    title: "MASTER",
    menus: [
      {
        name: "Master Data",
        icon: <AiFillDatabase size={25} />,
        path: null,
        submenus: [
          {
            name: "Parent Komponen",
            path: "/operator-pasca/master/parent-komponen-penilaian",
          },
          {
            name: "Komponen Penilaian",
            path: "/operator-pasca/master/komponen-penilaian",
          },
          {
            name: "Bobot Penilaian",
            path: "/operator-pasca/master/bobot-komponen-penilaian",
          },
          {
            name: "Bobot Karyatulis",
            path: "/operator-pasca/master/bobot-komponen-karyatulis",
          },
        ],
      },
    ],
  },
  {
    title: "SETTING",
    menus: [
      {
        name: "Verifikator",
        path: "/operator-pasca/setting/verifikator",
        icon: <RiSettings3Fill size={25} />,
      },
    ],
  },
];

export const operatorInternasionalNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/operator-internasional/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Data Pendaftaran",
        path: "/operator-internasional/data-pendaftaran",
        icon: <RiContactsBook3Fill size={25} />,
      },
    ],
  },
];

export const verifikatorPascaNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Verifikasi & Penilaian",
        path: "/verifikator-pasca/penilaian",
        icon: <LuCheckCheck size={25} />,
      },
      {
        name: "Data Nilai",
        path: "/verifikator-pasca/data-nilai",
        icon: <IoBarChartSharp size={25} />,
      },
    ],
  },
];

export const akademikNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Dashboard",
        path: "/akademik/dashboard",
        icon: <MdDashboard size={25} />,
      },
      {
        name: "Data Pendaftaran",
        path: "/akademik/data-pendaftaran",
        icon: <RiContactsBook3Fill size={25} />,
      },
    ],
  },
];

export const operatorStudentExchangeNavigations: Navigation[] = [
  {
    title: "MAIN",
    menus: [
      {
        name: "Data Pendaftaran",
        path: "/operator-studentexchange/data-pendaftaran",
        icon: <RiContactsBook3Fill size={25} />,
      },
    ],
  },
  {
    title: "SETTING",
    menus: [
      {
        icon: <RiSettings3Fill size={25} />,
        name: "Setting Periode",
        path: "/operator-studentexchange/setting/periode",
      },
    ],
  },
];

export const listRole: Role[] = [
  "superadmin",
  "pimpinan",
  "siswa",
  "verifikator_ukt",
  "verifikator_ukt_all",
  "verifikator_butawarna",
  "verifikator_butawarna_all",
  "verifikator_raport",
  "verifikator_raport_all",
  "verifikator_skl",
  "verifikator_skl_all",
  "verifikator_sehat",
  "verifikator_sehat_all",
  "verifikator_kepemimpinan",
  "verifikator_kepemimpinan_all",
  "loket_1",
  "loket_2",
  "loket_3",
  "loket_4",
  "loket_5",
  "loket_all",
  "operator_pasca",
  "verifikator_pasca",
  "panitia_smbjm",
  "akademik",
  "wawancara_talent",
  "operator_internasional",
  "operator_studentexchange",
  "api",
];

export const listSize = ["S", "M", "L", "XL", "XXL", "XXXL"];
export const listSizeOptions = [
  { label: "S", value: "S" },
  { label: "M", value: "M" },
  { label: "L", value: "L" },
  { label: "XL", value: "XL" },
  { label: "XXL", value: "XXL" },
  { label: "XXXL", value: "XXXL" },
];

export const listAkreditasi = [
  "A",
  "B",
  "C",
  "Cukup",
  "Baik",
  "Baik Sekali",
  "Unggul",
  "Lainnya",
];

export const listAkreditasiInternasional = ["Accredited", "Not Accredited"];

export const listKebutuhanKhusus = [
  "Tuna Netra",
  "Tuna Rungu",
  "Tuna Grahita Ringan",
  "Tuna Grahita Sedang",
  "Tuna Daksa Ringan",
  "Tuna Daksa Sedang",
  "Tuna Laras",
  "Tuna Wicara",
  "Hiperaktif",
  "Cerdas Istimewa",
  "Bakat Istimewa",
  "Kesulitan Belajar",
  "Narkoba",
  "Indigo",
  "Down Syndrome",
  "Autis",
];

export const listStatusKeluarga = [
  { label: "Masih Hidup", value: "H" },
  { label: "Wafat", value: "M" },
  { label: "Bercerai", value: "C" },
];

export const listJenisKelamin = [
  { label: "Laki-laki", value: "L" },
  { label: "Perempuan", value: "P" },
];

export const listKurikulum = [
  {
    label: "Kurikulum 2013",
    value: "2013",
  },
  {
    label: "Kurikulum Merdeka",
    value: "merdeka",
  },
];

export const listSemester = [
  {
    kelas: "X",
    semester: 1,
    alias: "Kelas 10 Semester Ganjil",
  },
  {
    kelas: "X",
    semester: 2,
    alias: "Kelas 10 Semester Genap",
  },
  {
    kelas: "XI",
    semester: 3,
    alias: "Kelas 11 Semester Ganjil",
  },
  {
    kelas: "XI",
    semester: 4,
    alias: "Kelas 11 Semester Genap",
  },
  {
    kelas: "XII",
    semester: 5,
    alias: "Kelas 12 Semester Ganjil",
  },
];

export const listKeteranganValidasiButawarna = [
  {
    label: "Tidak Butawarna",
    value: "N",
  },
  {
    label: "Buta Warna Parsial (Sebagian)",
    value: "YP",
  },
  {
    label: "Buta Warna Total",
    value: "YT",
  },
];

// export const listPanduanDaftarKembali = [
//   {
//     values: [
//       {
//         title: "Berkas-berkas yang disiapkan dalam pengisian data ini.",
//         instructions: ["Akta Kelahiran.", "Kartu Keluarga.", "KTP."],
//       },
//       {
//         title: "Tata Cara Pengisian",
//         instructions: [
//           "Masukkan Nama disesuaikan dengan Akta Kelahiran/Kartu Keluarga atau KTP SIM/ Ijazah Terakhir.",
//           "Masukkan Tempat Lahir disesuaikan dengan Akta Kelahiran/Kartu Keluarga atau KTP SIM/ Ijazah Terakhir.",
//           "Masukkan Nama Gadis Ibu Kandung.",
//           "Pilih Jenis Kelamin pada box yang sudah disediakan.",
//           "Masukkan Nomor telepon yang dapat dihubungi.",
//           "Masukkan Alamat Email sesuai dengan format yang benar.",
//           "Pilih Agama pada box yang sudah disediakan.",
//           "Masukkan Nomor KTP/NIK.",
//           "Masukkan Berat Badan Anda.",
//           "Masukkan Tinggi Anda.",
//           "Isikan Ukuran Jas Almamater Anda.",
//           "Isikan Ukuran Baju OKK Anda.",
//           "Masukkan Kewarganegaraan Anda.",
//           "Masukkan Alamat Anda.",
//           "Masukkan Desa/Kelurahan Anda.",
//           "Pilih Provinsi asal Anda.",
//           "Pilih Kabupaten asal Anda.",
//           "Pilih Kecamatan asal Anda.",
//           "Pilih Sekolah SMK/SMA/MA.",
//           "Isikan Status Asuh Anda.",
//           "Isikan Nama Panti Asuhan jika diasuh oleh Panti Asuhan.",
//           "Isikan Alat Transportasi Anda.",
//           "Isikan Kebutuhan Khusus Anda dengan mencentang pilihan yang disediakan.",
//           "Isikan Jumlah tanggungan orang tua/wali.",
//         ],
//       },
//     ],
//   },
//   {
//     values: [
//       {
//         title: "Berkas-berkas yang disiapkan dalam pengisian data ini.",
//         instructions: [
//           "Kartu Keluarga (KK)",
//           "SLIP Gaji Ayah",
//           "SLIP Gaji Ibu",
//         ],
//       },
//       {
//         title: "Ketentuan",
//         instructions: [
//           "Masukan data keluarga sesuai KK yang berlaku.",
//           "Anda wajib memasukkan minimal data ibu.",
//           "Semua form yang disediakan wajib diisi.",
//           "Wajib melampirkan slip gaji bagi ayah atau ibu atau wali yang bekerja.",
//         ],
//       },
//       {
//         title: "Tata Cara Pengisian",
//         instructions: [
//           "Masukkan Nama Keluarga, sesuai dengan yang tertera pada Kartu Keluarga",
//           "Pilih Hubungan Keluarga pada box yang sudah disediakan.",
//           "Pilih Status pada box yang sudah disediakan.",
//           "Pilih Jenis Kelamin pada box yang sudah disediakan.",
//           "Masukkan tanggal lahir keluarga sesuai dengan format yyyy-mm-dd (tahun-bulan-tanggal)",
//           "Pilih Pekerjaan keluarga tersebut.",
//           "Masukkan jumlah pendapatan kotor yang dimiliki oleh keluarga. (Sesuai dengan SLIP jika ada)",
//           "",
//         ],
//       },
//     ],
//   },
//   {
//     values: [
//       {
//         title: "Berkas-berkas yang disiapkan dalam pengisian data ini.",
//         instructions: [
//           "Pembayaran Pajak Bumi dan Bangunan Terakhir.",
//           "Pembayaran Listrik Bulan Terakhir.",
//           "Pembayaran Air Bulan Terakhir.",
//         ],
//       },
//       {
//         title: "Ketentuan",
//         instructions: [
//           "Anda wajib memasukkan data Rumah Tinggal.",
//           `Jika data "Rumah Tinggal" tidak diisi, maka proses tidak dapat dilanjutkan.`,
//           "Pembayaran Air Bulan Terakhir.",
//         ],
//       },
//       {
//         title: "Tata Cara Pengisian",
//         instructions: [
//           "Pilih Jenis Tanah dan Rumah.",
//           "Pilih Status Kepemilikan Tanah dan Bangunan.",
//           "Masukkan Tegangan Listrik sesuai yang tertera pada Bukti Pembayaran Listrik Terakhir.",
//           "Masukkan Jumlah Pembayaran Air terakhir sesuai yang tertera pada Bukti Pembayaran Air Terakhir.",
//           "Masukkan Luas Tanah sesuai dengan Bukti Pembayaran PBB teakhir. (dalam satuan m2)",
//           "Masukkan NJOP Tanah sesuai dengan Bukti Pembayaran PBB teakhir.",
//           "Masukkan Luas Bangunan sesuai dengan Bukti Pembayaran PBB teakhir. (dalam satuan m2)",
//           "Masukkan NJOP Bangunan sesuai dengan Bukti Pembayaran PBB teakhir.",
//           "Masukkan Total NJOP Wajib Pajak.",
//           "Masukkan Status Kepemilikan Tanah dan Rumah.",
//         ],
//       },
//     ],
//   },
//   {
//     values: [
//       {
//         title:
//           "BERIKUT BERKAS-BERKAS YANG HARUS DI UNGGAH KE DALAM SISTEM UNTUK MENUNJANG VALIDASI DATA",
//         instructions: [
//           "Surat Pernyataan. (*wajib). catatan : untuk menganti silahkan unggah ulang, secara otomatis akan diganti. Gunakan format PDF jika surat pernyataan melebihi 1 halaman.",
//         ],
//       },
//     ],
//   },
//   {
//     values: [
//       {
//         title: "Validasi Data yang telah diinputkan",
//         instructions: ["Biodata", "Keluarga", "Aset", "Berkas"],
//       },
//     ],
//   },
// ];

export const listPanduanDaftarKembali = [
  {
    title: "Biodata",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: ["Foto"],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Klik kolom yang mau diisi",
          "Isi data dengan benar sesuai kolom yang diminta",
        ],
      },
    ],
  },
  {
    title: "Keluarga",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: [
          "Kartu Keluarga",
          "Slip Gaji/Surat Keterangan Penghasilan Ayah / Surat Keterangan Meninggal",
          "Slip Gaji/Surat Keterangan Penghasilan Ibu / Surat Keterangan Meninggal",
        ],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Tekan tombol tambah untuk menambahkan data keluarga",
          "Isi data dengan benar sesuai kolom yang diminta",
          "Tekan tombol 'Simpan Data Keluarga'",
          "Isikan data tambahan pada kotak bagian bawah",
          "Tekan 'Simpan Data Tambahan'",
        ],
      },
    ],
  },
  {
    title: "Aset",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: [
          "Pembayaran Listrik Bulan Terakhir.",
          "Pembayaran Air Bulan Terakhir.",
          "Pembayaran Pajak Bumi dan Bangunan",
        ],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Tekan tombol 'Tambah' untuk menambahkan data aset",
          "Isikan data dengan benar sesuai kolom yang diminta",
          "Tekan tombol 'Simpan Data Aset'",
        ],
      },
    ],
  },
  {
    title: "Berkas",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: [
          "Dapat dilihat pada tabel. (Berkas yang berisi label (*Wajib) adalah berkas yang wajib untuk dipload.",
        ],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Khusus untuk berkas yang memiliki format (ditandai dengan Tombol Unduh pada kolom Format) lakukan unduh terlebih dahulu",
          "Tekan tombol 'Upload'",
          "Pilih file berkas",
          "Isikan nomor berkas jika ada",
          "Tekan tombol 'Simpan File Berkas'",
        ],
      },
    ],
  },
  {
    title: "Validasi",
    contents: [
      {
        title: "Tata cara pengisian",
        instructions: [
          "Tekan salah satu step untuk membuka kolom yang perlu divalidasi (contoh: Biodata)",
          "Tekan icon 'Centang' untuk melakukan validasi isian data",
          "Lakukan hingga step terakhir",
          "Baca ketentuan & centang ketentuan pada text yang berwarna merah",
          "Jika sudah, lakukan validasi permanen pada menggunakan tombol 'Validasi Permanen'",
          "Isi survey dan unggah 'Surat Pernyataan'",
          "Pastikan seluruh data sudah diisi dengan benar. Tekan tombol 'Ya, Validasi Permanen'",
          "Data yang telah di validasi permanen, tidak dapat diubah kembali. Pastikan semua data telah diisi dengan benar.",
        ],
      },
    ],
  },
];

export const listPanduanPenerimaan = [
  {
    title: "Biodata",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: ["Foto"],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Klik kolom yang mau diisi",
          "Isi data dengan benar sesuai kolom yang diminta",
        ],
      },
    ],
  },
  {
    title: "Prodi",
    contents: [],
  },
  {
    title: "Nilai Rapor",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: ["Rapor"],
      },
      {
        title: "Tata cara pengisian",
        instructions: ["Isi aja"],
      },
    ],
  },
];

export const listPanduanPenerimaanCbt = [
  {
    title: "Biodata",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: ["Foto"],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Klik kolom yang mau diisi",
          "Isi data dengan benar sesuai kolom yang diminta",
        ],
      },
    ],
  },
  {
    title: "Berkas",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: [
          "Dapat dilihat pada tabel. (Berkas yang berisi label (*Wajib) adalah berkas yang wajib untuk dipload.",
        ],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Khusus untuk berkas yang memiliki format (ditandai dengan Tombol Unduh pada kolom Format) lakukan unduh terlebih dahulu",
          "Tekan tombol 'Upload'",
          "Pilih file berkas",
          "Isikan nomor berkas jika ada",
          "Tekan tombol 'Simpan File Berkas'",
        ],
      },
    ],
  },
];

export const listPanduanPenerimaanPrestasi = [
  {
    title: "Biodata",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: ["Foto"],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Klik kolom yang mau diisi",
          "Isi data dengan benar sesuai kolom yang diminta",
        ],
      },
    ],
  },
  {
    title: "Berkas",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: [
          "Dapat dilihat pada tabel. (Berkas yang berisi label (*Wajib) adalah berkas yang wajib untuk dipload.",
        ],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Khusus untuk berkas yang memiliki format (ditandai dengan Tombol Unduh pada kolom Format) lakukan unduh terlebih dahulu",
          "Tekan tombol 'Upload'",
          "Pilih file berkas",
          "Isikan nomor berkas jika ada",
          "Tekan tombol 'Simpan File Berkas'",
        ],
      },
    ],
  },
];

export const listPanduanPenerimaanTalent = [
  {
    title: "Biodata",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: ["Foto"],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Klik kolom yang mau diisi",
          "Isi data dengan benar sesuai kolom yang diminta",
        ],
      },
    ],
  },
  {
    title: "Berkas",
    contents: [
      {
        title: "Berkas yang dibutuhkan",
        instructions: [
          "Dapat dilihat pada tabel. (Berkas yang berisi label (*Wajib) adalah berkas yang wajib untuk dipload.",
        ],
      },
      {
        title: "Tata cara pengisian",
        instructions: [
          "Khusus untuk berkas yang memiliki format (ditandai dengan Tombol Unduh pada kolom Format) lakukan unduh terlebih dahulu",
          "Tekan tombol 'Upload'",
          "Pilih file berkas",
          "Isikan nomor berkas jika ada",
          "Tekan tombol 'Simpan File Berkas'",
        ],
      },
    ],
  },
];

export const listPanduanLoketDaftarKembali = [
  {
    values: [
      {
        title: "Berkas-berkas yang disiapkan dalam tahap ini.",
        instructions: [
          "Kartu Tanda Peserta SNBP",
          "Biodata Peserta yang diperoleh dari Sistem Pendaftaran Kembali",
          "Bukti Pembayaran UKT dari Bank atau Bukti Penerima KIPK bagi Penerima KIPK",
        ],
      },
      {
        title: "Tata cara validasi",
        instructions: [
          "Masukkan Nomor Pendaftaran/Nama pada kotak pencarian yang telah disediakan, lalu Klik tombol Cari",
          "Jika sistem mendeteksi belum membayar, silahkan di arahkan dulu ke loket Pembayaran dan meminta kembali lagi pada Loket ini untuk di Validasi.",
          "Jika sistem mendeteksi sudah membayar UKT(bagi yang kena UKT) atau Penerima KIPK Validasi dapat dilakukan.",
          "Pilih Valid pada menu validasi jika data dinyatakan valid, begitu sebaliknya",
          "Tekan Tombol Valid",
        ],
      },
    ],
  },
  {
    values: [
      {
        title: "Berkas-berkas yang disiapkan dalam tahap ini.",
        instructions: [
          "Biodata Peserta yang diperoleh dari sistem pendaftaran daftarkembali.",
          "Bukti pembayaran Briva asli dari Bank/Bukti Penerima KIPK",
        ],
      },
      {
        title: "Daftar Prodi yang akan melakukan tes Buta Warna.",
        instructions: [
          "Desain Komunikasi Visual (D3)",
          "Pendidikan Seni Rupa (S1)",
          "Analis Kimia (D3)",
          "Kimia Terapan (D4)",
          "Pendidikan Fisika (S1)",
          "Pendidikan Kimia (S1)",
          "Pendidikan Biologi (S1)",
          "Biologi (S1)",
          "Fisika (S1)",
          "Pendidikan IPA (S1)",
          "Teknik Elektronika (D3)",
          "Teknologi Rekayasa Sistem Elektronika (D4)",
          "Pendidikan Vokasional Seni Kuliner (S1)",
          "Kebidanan (D3)",
          "Kedokteran (S1)",
          "Keperawatan (S1)",
          "Kebidanan (S1)",
          "Pendidikan Profesi Ners",
          "Pendidikan Profesi Bidan",
        ],
      },
      {
        title: "Tata Cara Pengisian",
        instructions: [
          "Masukkan Nomor Pendaftaran pada text field yang telah disediakan",
          "Tekan tombol cari",
          "Jika peserta telah melakukan pembayaran ukt, maka data peserta akan muncul. Jika peserta tidak ditemukan, kemungkinan peserta belum melakukan pembayaran atau prodi tidak perlu melakukan cek butawarna.",
          "Pilih Valid pada menu validasi jika data dinyatakan valid, begitu sebaliknya",
          "Tekan Tombol Save",
        ],
      },
    ],
  },
  {
    values: [
      {
        title: "Berkas-berkas yang disiapkan calon mahasiswa dalam tahap ini.",
        instructions: [
          "Biodata yang dicetak melalui system Pendaftaran Kembali.",
          "Printout E-FBM (Formulir Pendaftaran KIP Kuliah Tahun 2024)",
          "Kartu Peserta KIP Kuliah Tahun 2024",
          "Surat Rekomendasi Kepala Sekolah/Madrasah",
          "Fotocopy Kartu Beasiswa Siswa Miskin (BSM)",
          "Fotocopy Kartu Kesejahteraan Sosial (KKS) atau Sejenisnya",
          "Fotocopy Kartu Tanda Siswa (KTS) atau yang sejenisnya sebagai bukti siswa di SMA/SMK/Madrasah",
          "Fotocopy rapor semester 1 (satu) s/d 5 (lima) yang dilegalisir oleh Kepala Sekolah/Madrasah",
          "Fotocopy ijasah dan nilai ujian akhir nasional yang dilegalisir oleh Kepala Sekolah (Apabila belum ada agar melampirkan surat keterangan lulus dari Kepala Sekolah)",
          "Surat keterangan tentang peringkat siswa di kelas dan bukti pendukung prestasi lain di bidang keilmuan/akademik, olahraga dan seni yang dilegalisir oleh Kepala Sekolah/Madrasah",
          "Surat Keterangan Penghasilan Orang Tua/Wali dan Surat Keterangan Tidak Mampu yang dikeluarkan oleh Ketua RT/Kepala Dusun yang disahkan oleh Lurah/Kepala Desa atau pimpinan instansi tempat orang tua bekerja",
          "Fotocopy Kartu Keluarga yang dilegalisir oleh Lurah/Kepala Desa",
          "Fotocopy rekening listrik bulan terakhir (apabila tersedia aliran listrik) dan bukti pembayaran PBB dari orang tua/wali-nya (apabila mempunyai bukti pembayaran)",
        ],
      },
      {
        title: "Tata Cara Pengisian",
        instructions: [
          "Masukkan Nomor Pendaftaran pada text field yang telah disediakan",
          "Klik tombol cari",
          "Jika peserta telah melalui tahap sebelumnya, maka data peserta akan muncul. Jika peserta tidak ditemukan, kemungkinan peserta belum melalui tahap sebelumnya.",
          "Pilih Valid pada menu validasi jika data dinyatakan valid, begitu sebaliknya",
          "Klik Tombol Save",
        ],
      },
    ],
  },
  {
    values: [
      {
        title: "Berkas-berkas yang disiapkan dalam tahap ini.",
        instructions: [
          "Biodata yang dicetak melalui sistem Pendaftaran Kembali.",
          "Surat Keterangan Lulus / Ijazah Asli.",
          "Rapor Asli. (khusus pelamar SNBP)",
          "Sertifikat Prestasi asli (khusus pelamar SNBP dan bagi yang mengunggah saat daftar SNBP)",
        ],
      },
      {
        title: "Tata Cara Pengisian",
        instructions: [
          "Masukkan Nomor Pendaftaran pada text field yang telah disediakan",
          "Tekan tombol cari",
          "Jika peserta telah melalui tahap sebelumnya, maka data peserta akan muncul. Jika peserta tidak ditemukan, kemungkinan peserta belum melalui tahap sebelumnya.",
          "Pilih valid pada menu validasi jika data dinyatakan valid, begitu sebaliknya",
          "Tekan tombol valid",
        ],
      },
    ],
  },
  {
    values: [
      {
        title: "Berkas-berkas yang disiapkan dalam tahap ini.",
        instructions: [
          "Biodata Peserta yang diperoleh dari sistem pendaftaran ulang",
          "Surat Keterangan Lulus / Ijazah",
        ],
      },
      {
        title: "Tata Cara Pengisian",
        instructions: [
          "Masukkan Nomor Pendaftaran pada text field yang telah disediakan",
          "Tekan tombol cari",
          "Jika peserta telah melalui tahap sebelumnya, maka data peserta akan muncul. Jika peserta tidak ditemukan, kemungkinan peserta belum melalui tahap sebelumnya.",
          "Pilih Valid pada menu validasi jika data dinyatakan valid, begitu sebaliknya",
          "NIM dan email akan terisi otomatis",
          "Klik Tombol Save",
        ],
      },
    ],
  },
];

export const listSumberInformasi = [
  { label: "Sosial Media", value: "Sosial Media" },
  { label: "Website", value: "Website" },
  { label: "Teman/Keluarga", value: "Teman/Keluarga" },
  { label: "Sekolah", value: "Sekolah" },
  {
    label: `Sosialisasi ${web.univAcronym}`,
    value: `Sosialisasi ${web.univAcronym}`,
  },
];

export const listBentukPendidikan = ["SMA", "SMK", "MA", "SPK-SMA", "PKBM"];

export const listLokasiKuliah = ["Singaraja", "Denpasar"];

export const listPaymentMethod = [
  {
    name: "BRI | Bank Rakyat Indonesia",
    payment_gateway_id: 1,
    logo: LogoBRI,
    active: true,
  },
  {
    name: "BPD Bali | Bank Pembangunan Daerah Bali",
    payment_gateway_id: 3,
    logo: LogoBPD,
    active: false,
  },
  {
    name: "MANDIRI | Bank Mandiri",
    payment_gateway_id: 4,
    logo: LogoMandiri,
    active: false,
  },
  {
    name: "BNI | Bank Negara Indonesia",
    payment_gateway_id: 5,
    logo: LogoBNI,
    active: false,
  },
  {
    name: "BTN | Bank Tabungan Negara",
    payment_gateway_id: 6,
    logo: LogoBTN,
    active: false,
  },
  {
    name: "BSI | Bank Syariah Indonesia",
    payment_gateway_id: 11,
    logo: LogoBSI,
    active: false,
  },
];

export const listStatusPembayaran = [
  {
    status: 1,
    text: "Belum dibayar",
  },
  {
    status: 2,
    text: "Sudah dibayar",
  },
  {
    status: 3,
    text: "Expired",
  },
  {
    status: 4,
    text: "Sudah dibayar (tunda)",
  },
  {
    status: 5,
    text: "Beasiswa",
  },
];

export const listJenisPortofolio = [
  {
    label: "Olahraga",
    value: "olahraga",
  },
  {
    label: "Seni",
    value: "seni",
  },
];

export const listJenisRuang = [
  {
    label: "Daring",
    value: "daring",
  },
  {
    label: "Luring",
    value: "luring",
  },
];

export const listHubunganKeluarga = [
  { labelEn: "Father", label: "Ayah", value: "ayah" },
  { labelEn: "Mother", label: "Ibu", value: "ibu" },
  { labelEn: "Guardian", label: "Wali", value: "wali" },
  { labelEn: "Spouse", label: "Pasangan", value: "pasangan" },
  { labelEn: "Sibling", label: "Saudara", value: "saudara" },
  { labelEn: "Relative", label: "Kerabat", value: "kerabat" },
  { labelEn: "Friend", label: "Teman", value: "teman" },
  { labelEn: "Other", label: "Lainnya", value: "lainnya" },
];

export const listGolonganDarah = [
  { label: "A", value: "A" },
  { label: "B", value: "B" },
  { label: "AB", value: "AB" },
  { label: "O", value: "O" },
];

export const listLingkup = [
  { label: "Sekolah", value: "sekolah" },
  { label: "Luar Sekolah", value: "luar_sekolah" },
];

export const listJabatan = [
  { label: "Ketua", value: "ketua" },
  { label: "Wakil Ketua", value: "wakil_ketua" },
  { label: "Sekretaris", value: "sekretaris" },
  { label: "Bendahara", value: "bendahara" },
];
